import { Component, Input } from '@angular/core';
import { CategorieCard } from '../interfaces/categorie-card';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-categorie-card',
  imports: [RouterLink],
  templateUrl: './categorie-card.component.html',
  styleUrl: './categorie-card.component.scss'
})
export class CategorieCardComponent {
  @Input() card : CategorieCard = { titulo : "", subtitulo : "", periodo : "", iconeNome : "cycle.svg", tipoCard  : "", botaoHabilitado: false, objetivos : ["objetivo 1", "objetivo 2", "objetivo 3"] }

  caminho : string = "../../../../../assets/icons/";
  iconeCaminho : string = "";

  ngOnInit(){
    this.iconeCaminho  = this.caminho + this.card.iconeNome;
  }

  /*
  ESTRUTURA DA INTERFACE (CategorieCard)
  --------------------------------------
  - Titulo -> Título maior do componente, a sigla. É uma string comum e variável.

  - Subtitulo -> Subtitulo do componente, o significado da sigla. É uma string comum e variável.

  - Periodo -> Ano(s) de implementação do projeto representado no card. Deve ser definido como uma string. Exemplo: 2024-2025.

  - IconeNome -> O nome do ícone que vai ser representado no card. Os ícones têm que estar presentes na pasta assets/icons, como representado na variável caminho. Exemplo: icone-card.svg.

  - TipoCard -> Essa variável tem três tipos de valores, que são os cards prototipados até então: ppa, loa e ldo (tudo minúsculo). Se essa variável não for definida, ou for definida com um nome diferente dos que foram apresentados, é apresentado um estilo "standard", com cores cinza.

  - BotaoHabilitado -> Define se o botão "Participe" estará habilitado ou desabilitado. É um valor booleano, true para habilitado e false para desabilitado.

  - Objetivos -> Lista de strings dos objetivos que devem ser listados no card.

  */

  /*
  EXEMPLO DE USO EM UM COMPONENTE PAI
  -----------------------------------

  Variável TypeScript
    cardPpa : CategorieCard = {
      titulo: "PPA",
      subtitulo: "Plano Plurianual",
      periodo: "2026",
      iconeNome: "icone-ppa.svg",
      tipoCard: "ppa",
      botaoHabilitado: true,
      objetivos: ["Objetivo 1", "Objetivo 2", "Objetivo 3"]
    }

  Template HTML
    <app-categorie-card [card] = "cardPpa" />

  */
}
